import React from "react";

const processReactNodes = (nodes, match, processNode) => {
  if (!nodes) return null;

  return React.Children.map(nodes, node => {
    if (typeof node === "string") {
      return processNode(node);
    }

    if (React.isValidElement(node)) {
      const { children, ...otherProps } = node.props;
      return React.cloneElement(
        node,
        { ...otherProps },
        processReactNodes(children, match, processNode)
      );
    }

    return node;
  });
};

const escapeRegExpSpecialCharacters = string =>
  string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

export const BoldMatch = props => {
  const { text = "", match = "" } = props;
  if (!match) return text;

  // Split input into terms and sort longest-first
  const terms = match
    .split(/\s+/)
    .filter(Boolean)
    .map(escapeRegExpSpecialCharacters)
    .sort((a, b) => b.length - a.length);

  const regex = new RegExp(`(${terms.join("|")})`, "gi");

  const processNode = node => {
    const parts = node.split(regex);

    return parts.map((part, i) => {
      // eslint-disable-next-line react/no-array-index-key
      return regex.test(part) ? <b key={`${part}-${i}`}>{part}</b> : part;
    });
  };

  return processReactNodes(text, match, processNode);
};
